import "./walk-in-panel";
import WalkInPanel from "./walk-in-panel";

export class WalkInRenderPanel extends WalkInPanel {

    connectedCallback() {
        this.innerHTML = `<h1>Render</h1>`;
    }
}
export default WalkInRenderPanel;
window.customElements.define('walk-in-render-panel', WalkInRenderPanel);
